import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Select } from 'antd';
import Shipping from '../../classes/shipping';
import { FormInstance } from 'antd/lib/form';
import { ValidationPatterns } from '../../config/config';
import { useTranslation } from 'react-i18next';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const { postalCodePattern } = ValidationPatterns;
const { Option } = Select;
const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
};

interface IProps {
    data: Shipping;
    formIsValid: (isValid: boolean, values?: any) => void;
    nextStep: () => void;
}

const ShippingForm = (props: IProps) => {
    const { t } = useTranslation();
    const formRef = useRef<FormInstance>(null);
    const [cities, setCities] = useState<simpleStruct[]>([]);

    const onFinish = (values: any) => {
        if (document.getElementById('city-' + values.cityId) !== null) {
            values.city = document.getElementById('city-' + values.cityId)!.getAttribute('data-city');
            values.provinceId = document.getElementById('city-' + values.cityId)!.getAttribute('data-province');
        }
        props.formIsValid(true, values);
        props.nextStep();
    };

    const onFinishFailed = () => {
        props.formIsValid(false);
    };

    const onCitySelected = async (value: any) => {
        formRef.current!.setFieldsValue({ postalCode: document.getElementById('city-' + value)!.getAttribute('data-postalcode') });
    };

    useEffect(() => {
        const getCities = async () => {
            const cities = await SicuriProtettiServices.getCities('IT');
            setCities(cities);
        };

        getCities();
        // eslint-disable-next-line
    }, []);

    return (
        <Form id="shipping-form" className="center" ref={formRef} onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <h2 className="font-weight-600 title-content">{t('sicuri&protetti.titles.title4A')}</h2>

            <Form.Item
                {...formItemLayout}
                name="cityId"
                label={t('commonClass.city')}
                initialValue={props.data.cityId}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.cityReq'),
                    },
                ]}
            >
                <Select
                    placeholder={t('commonClass.city')}
                    showSearch
                    optionFilterProp="children"
                    onSelect={onCitySelected}
                    filterOption={(input, option) => option!.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    {cities.map((city) => (
                        <Option
                            key={city.value}
                            value={city.value}
                            id={'city-' + city.value}
                            data-city={city.label}
                            data-province={city.additionalData[0]}
                            data-postalcode={city.additionalData[1]}
                        >
                            {city.label}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="postalCode"
                label={t('customerClass.postalCode')}
                initialValue={props.data.postalCode}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.postalCodeReq'),
                    },
                    {
                        pattern: postalCodePattern,
                        message: t('errorMessages.postalCodeValid'),
                    },
                ]}
            >
                <Input placeholder={t('customerClass.postalCodeSN')} />
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="address"
                label={t('customerClass.address')}
                initialValue={props.data.address}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.residentialAddressReq'),
                    },
                ]}
            >
                <Input placeholder={t('customerClass.address')} />
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="referenceName"
                label={t('commonClass.referenceName')}
                initialValue={props.data.referenceName}
                rules={[
                    {
                        required: true,
                        message: t('errorMessages.referenceNameReq'),
                    },
                ]}
            >
                <Input placeholder={t('commonClass.referenceName')} />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" id="shipping-submit" hidden />
            </Form.Item>
        </Form>
    );
};

export default ShippingForm;
